/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { ProblemConflict } from './ProblemConflict';
import { ProblemConflictBlobRestoreInProgress } from './ProblemConflictBlobRestoreInProgress';
import { ProblemConflictResource } from './ProblemConflictResource';

export const ConflictProblems: core.serialization.Schema<serializers.ConflictProblems.Raw, Truvity.ConflictProblems> =
    core.serialization
        .union('type', {
            '/conflict': ProblemConflict,
            '/conflict/blob/restore-in-progress': ProblemConflictBlobRestoreInProgress,
            '/conflict/resource': ProblemConflictResource,
        })
        .transform<Truvity.ConflictProblems>({
            transform: (value) => value,
            untransform: (value) => value,
        });

export declare namespace ConflictProblems {
    export type Raw =
        | ConflictProblems.Conflict
        | ConflictProblems.ConflictBlobRestoreInProgress
        | ConflictProblems.ConflictResource;

    export interface Conflict extends ProblemConflict.Raw {
        type: '/conflict';
    }

    export interface ConflictBlobRestoreInProgress extends ProblemConflictBlobRestoreInProgress.Raw {
        type: '/conflict/blob/restore-in-progress';
    }

    export interface ConflictResource extends ProblemConflictResource.Raw {
        type: '/conflict/resource';
    }
}
